export const colors = {
    primary: "#004376",
    secondary: "#9f2936",
    textPrimary: "#00508c",
    textSecondary: "#a02936",
    infoText: "#181315",
    background: "#fff"
}